<script setup lang="ts">
import {
  iButton,
  iButtonTypes,
  iButtonStyles,
  iButtonSizes,
  iTextInput,
} from '@inscribe/signal';

interface Props {
  label: string;
}

interface Emits {
  (e: 'remove'): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div
    class="filter-editor-layout d-flex flex-column i-gap-6"
    :data-testid="`filter-${label.toLowerCase().replace(/\s+/g, '-')}`"
  >
    <!-- Main row -->
    <div class="d-flex flex-row align-items-start i-gap-6">
      <!-- Label -->
      <div class="filter-section filter-label-section">
        <i-text-input :model-value="label" :read-only="true" />
      </div>

      <!-- Input fields slot -->
      <slot />

      <!-- Delete filter button -->
      <div class="flex-shrink-0">
        <i-button
          :type="iButtonTypes.NEUTRAL"
          :button-style="iButtonStyles.GHOST"
          :size="iButtonSizes.LARGE"
          left-icon="medium-delete-bin-1"
          @button-click="emit('remove')"
        />
      </div>
    </div>

    <!-- Additional content after main row (e.g., badges for free text mode) -->
    <slot name="after" />
  </div>
</template>
